import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import StyledButton from "../StyledButton/StyledButton";
import styled, { withTheme } from "styled-components";

const StyledPrimaryBtn = styled(StyledButton)`
  color: ${(props) => props?.theme?.white};
  background-color: ${(props) => props?.theme?.darkPurple};
  border-color: ${(props) => props?.theme?.darkPurple};
  &:hover {
    color: ${(props) => props?.theme?.white} !important;
    background-color: ${(props) => props?.theme?.persianIndigo} !important;
    border-color: ${(props) => props?.theme?.persianIndigo} !important;
  }
  &:focus {
    color: ${(props) => props?.theme?.white};
    background-color: ${(props) => props?.theme?.darkPurple};
    border-color: ${(props) => props?.theme?.darkPurple};
    box-shadow: ${(props) => props?.theme?.primaryShadow};
  }
  &:disabled,
  &:not(:disabled):not(.disabled):active,
  :not(:disabled):not(.disabled).active,
  .show > .dropdown-toggle {
    color: ${(props) => props?.theme?.white};
    background-color: ${(props) => props?.theme?.lavenderRose};
    border-color: ${(props) => props?.theme?.lavenderRose};
  }
  &:not(:disabled):not(.disabled):active:focus,
  .show > .dropdown-toggle:focus {
    box-shadow: ${(props) => props?.theme?.lavenderShadow};
  }
`;

const PrimaryButton = (props) => {
  const { text, size, type } = props;
  const btnRef = useRef(null);

  useEffect(() => {
    if (btnRef.current && type === "submit") {
      btnRef.current.focus();
    }
  }, [btnRef, type]);

  return (
    <StyledPrimaryBtn {...props} size={size} ref={btnRef}>
      {text || props.children}
    </StyledPrimaryBtn>
  );
};

PrimaryButton.propTypes = {
  size: PropTypes.oneOf(["lg", "", "sm"]),
};

export default withTheme(PrimaryButton);
